/**
 * Utilitaire de gestion de l'expiration de session.
 *
 * Ce module expose un flag synchrone (module-level) et une fonction de dispatch.
 * Le flag est consulté de manière synchrone par ToastContext pour supprimer les
 * toasts d'erreur qui apparaîtraient au même moment que la modale "Session expirée".
 */

let _expired = false;

/** Marque la session comme expirée (synchrone). */
export const markSessionExpired = () => { _expired = true; };

/** Réinitialise le flag après reconnexion. */
export const clearSessionExpired = () => { _expired = false; };

/** Retourne true si la session vient d'expirer. */
export const isSessionExpired = () => _expired;

/**
 * Marque la session expirée ET dispatch l'événement DOM 'session:expired'.
 * À appeler depuis la couche service (airtable.js) quand un 401 est reçu.
 */
export const dispatchSessionExpiredEvent = () => {
  markSessionExpired();
  window.dispatchEvent(new CustomEvent('session:expired'));
};
